'use client';

import { FormattedMessage } from 'react-intl';
import logWebHeaderLoginButtonTapped from '@alltrails/amplitude/events/logWebHeaderLoginButtonTapped';
import Button from '@alltrails/denali/components/Button';
import GetTheAppButton from './GetTheAppButton';
import { HeaderBackground } from './types';

type LoggedOutUserCtaProps = {
  background: HeaderBackground;
  onLogIn: () => void;
};

const LoggedOutUserCta = ({ background, onLogIn }: LoggedOutUserCtaProps) => {
  return (
    <>
      <GetTheAppButton variant="accent" />
      <Button
        onClick={() => {
          logWebHeaderLoginButtonTapped();
          onLogIn();
        }}
        size="sm"
        text={<FormattedMessage defaultMessage="Log in" />}
        variant={background === 'transparent-inverted' ? 'inverse' : 'primary'}
      />
    </>
  );
};

export default LoggedOutUserCta;
